import { useAtomValue } from 'jotai';

import { ItemWrapper } from './index.styles';

import Heading from '../../../../../../heading';
import PageWrapper from '../../../../../../page_wrapper';
import Items from '../../main/rewards/items';

import { vendorCardRewardsState } from '../../../../../../../store';

export default function RewardsMain() {
  const cardRewards = useAtomValue(vendorCardRewardsState);

  return (
    <PageWrapper>
      <Heading align="center">Rewards</Heading>
      <ItemWrapper>
        <Items items={cardRewards} />
      </ItemWrapper>
    </PageWrapper>
  );
}
